// Detect if user is on mobile
export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;

// Helper: Format time ago
export const formatTimeAgo = (timestamp) => {
  const now = new Date();
  const messageDate = new Date(timestamp);
  const diffMs = now - messageDate;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;
  return messageDate.toLocaleDateString();
};

export const CustomLoadingSpinner = ({ size = 48, message = 'Loading...' }) => {
  return `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px;">
      <style>
        @keyframes pinBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes pinPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.9; }
        }
        @keyframes peoplePulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
        @keyframes ripple {
          0% { transform: scale(0.8); opacity: 0.8; }
          100% { transform: scale(2); opacity: 0; }
        }
        .spinner-ripple {
          position: absolute;
          bottom: -4px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 8px;
          background: radial-gradient(ellipse, rgba(66,133,244,0.3) 0%, transparent 70%);
          border-radius: 50%;
          animation: ripple 1.5s ease-out infinite;
        }
        .spinner-ripple-2 {
          animation-delay: 0.75s;
        }
      </style>
      <div style="position: relative; width: ${size}px; height: ${size}px;">
        <!-- Ripple effects -->
        <div class="spinner-ripple"></div>
        <div class="spinner-ripple spinner-ripple-2"></div>
        
        <!-- Main pin SVG -->
        <svg 
          viewBox="0 0 60 80" 
          style="
            width: 100%; 
            height: 100%; 
            animation: pinBounce 1s ease-in-out infinite, pinPulse 2s ease-in-out infinite;
            filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
          "
        >
          <!-- Pin body -->
          <path 
            d="M30 2 C12 2 2 15 2 30 C2 50 30 78 30 78 C30 78 58 50 58 30 C58 15 48 2 30 2 Z" 
            fill="none" 
            stroke="#2c2c2c" 
            stroke-width="3"
          />
          
          <!-- Inner fill with gradient -->
          <path 
            d="M30 5 C14 5 5 16 5 29 C5 47 30 73 30 73 C30 73 55 47 55 29 C55 16 46 5 30 5 Z" 
            fill="white"
          />
          
          <!-- People group with pulse animation -->
          <g style="animation: peoplePulse 1.5s ease-in-out infinite;">
            <!-- Center person (front, larger) -->
            <circle cx="30" cy="24" r="6" fill="#2c2c2c"/>
            <ellipse cx="30" cy="40" rx="9" ry="7" fill="#2c2c2c"/>
            
            <!-- Left person -->
            <circle cx="16" cy="27" r="4.5" fill="#2c2c2c"/>
            <ellipse cx="16" cy="40" rx="6.5" ry="5" fill="#2c2c2c"/>
            
            <!-- Right person -->
            <circle cx="44" cy="27" r="4.5" fill="#2c2c2c"/>
            <ellipse cx="44" cy="40" rx="6.5" ry="5" fill="#2c2c2c"/>
          </g>
        </svg>
      </div>
      ${message ? `<p style="margin: 0; color: #5f6368; font-size: 14px; font-weight: 400; font-family: 'Outfit', sans-serif;">${message}</p>` : ''}
    </div>
  `;
};

// Shared error display helper for form validation
export const showError = (element, message) => {
  const existingError = element.parentElement.querySelector('.error-message');
  if (existingError) existingError.remove();

  const errorDiv = document.createElement('p');
  errorDiv.className = 'error-message';
  errorDiv.style.cssText = `
    font-size: 11px;
    color: #ea4335;
    margin-top: 4px;
    margin-bottom: 0;
    animation: slideDown 0.2s ease-out;
  `;
  errorDiv.textContent = message;

  if (!document.head.querySelector('style[data-error-animation]')) {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideDown {
        from { opacity: 0; transform: translateY(-5px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    style.setAttribute('data-error-animation', 'true');
    document.head.appendChild(style);
  }

  element.insertAdjacentElement('afterend', errorDiv);
  element.style.borderColor = '#ea4335';
};